<div style="min-height: 400px">
    <div class="sh-template-stack">
        <section class="sh-template-stack__item">
            @if (showSearch) {
                <med-thesaurus-search
                    [thesaurusDefDottedKey]="(thesaurusFieldDefinition$ | async)?.DottedKey"
                    [thesaurusSearchControl]="thesaurusSearchControl"
                    [setValue]="synchronizeConceptSelection$ | async"
                    [enableSuggestions]="enableSuggestions"
                    [suggestionLimitReached]="suggestionLimit$ | async"
                    [topConcept]="searchTopConcept$ | async"
                    [multiple]="selectMultiple"
                    [autoFocus]="autoFocus"
                    (selectedConcept)="onLookupSelection($event)"
                    (suggestion)="onSuggestion($event)"
                ></med-thesaurus-search>
            }
        </section>
        <section class="sh-template-stack__item" *ngIf="enableSuggestions">
            <med-thesaurus-tag-list
                *ngIf="(suggestions$ | async)?.length > 0"
                [id]="id + '-dialog'"
                [disabled]="disabled"
                [multiple]="selectMultiple"
                [placeholderMsg]=""
                [suggestions]="suggestions$ | async"
                [removableSuggestions]="false"
            >
            </med-thesaurus-tag-list>
            <p *ngIf="suggestionErrorMsg$ | async as errorMsg" [style]="'color: red;'" class="sh-form-group__feedback">{{ errorMsg }}</p>
        </section>

        <section class="sh-template-stack__item">
            <sh-tree-viewer
                *ngIf="treeViewNodes$ | async as treeViewNodes"
                [nodes]="treeViewNodes"
                [hideRootNodes]="hideRootNodes"
                [multiple]="selectMultiple"
                [loadingMsg]="'thesaurus.loading' | translate"
                [loadMoreMsg]="'thesaurus.load-more' | translate"
                [getChildrenFct]="getNodeNarrowerConcepts"
                (selectedNodes)="onSelectedNodesChange($event)"
                (updatedNodes)="onUpdatedNodes($event)"
            ></sh-tree-viewer>
        </section>
    </div>
</div>
